(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = 0;
        return;
      }

      this.header.classList.add('scrolled-past-header');

      if (scrollTop > this.currentScrollTop) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keuzehulp-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll(
      '.ss-choice[data-section-id]'
    );

    roots.forEach((root) => {
      if (root.dataset.choiceInitialized === 'true') return;

      root.dataset.choiceInitialized = 'true';

      const tree = JSON.parse(
        root.querySelector('[data-choice-tree]').textContent
      );

      const endpoints = JSON.parse(
        root.querySelector('[data-choice-endpoints]').textContent
      );

      const modal = root.querySelector('[data-choice-modal]');
      const quiz = root.querySelector('[data-choice-quiz]');
      const result = root.querySelector('[data-choice-result]');
      const question = root.querySelector('[data-choice-question]');
      const sub = root.querySelector('[data-choice-sub]');
      const step = root.querySelector('[data-choice-step]');
      const options = root.querySelector('[data-choice-options]');
      const back = root.querySelector('[data-choice-back]');
      const productTarget = root.querySelector(
        '[data-choice-product-target]'
      );

      const form = root.querySelector('.ss-choice__form');
      const sessionKey = `ss_choice_${root.dataset.sectionId}`;

      let history = [];
      let answers = [];
      let endpointCode = null;

      let sessionId = sessionStorage.getItem(
        'ss_choice_session_id'
      );

      if (!sessionId) {
        sessionId =
          window.crypto?.randomUUID?.() ||
          `${Date.now()}-${Math.random().toString(16).slice(2)}`;

        sessionStorage.setItem(
          'ss_choice_session_id',
          sessionId
        );
      }

      const track = (event, data = {}) => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event,
          choice_finder_version: '4.0',
          choice_finder_section: root.dataset.sectionId,
          choice_finder_session_id: sessionId,
          ...data
        });
      };

      const setProgress = () => {
        const value = endpointCode
          ? 100
          : Math.min(88, 16 + history.length * 18);

        root.querySelector(
          '[data-choice-progress]'
        ).style.width = `${value}%`;
      };

      const open = () => {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ss-choice-lock');

        track('choice_finder_opened');

        if (!endpointCode && history.length === 0) {
          renderNode('root');
        }

        setTimeout(() => {
          root.querySelector('[data-choice-close]')?.focus();
        }, 20);
      };

      const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ss-choice-lock');

        track('choice_finder_closed', {
          endpoint_id: endpointCode
        });
      };

      const renderNode = (nodeKey) => {
        const node = tree[nodeKey];

        if (!node) return;

        endpointCode = null;
        quiz.hidden = false;
        result.hidden = true;

        step.textContent = `Vraag ${history.length + 1}`;
        question.textContent = node.question;
        sub.textContent =
          node.sub ||
          'Kies het antwoord dat het beste past.';

        options.innerHTML = '';
        back.hidden = history.length === 0;

        node.options.forEach((option) => {
          const button = document.createElement('button');

          button.type = 'button';
          button.className = 'ss-choice__option';

          button.innerHTML =
            `<strong>${option.label}</strong>` +
            (option.description
              ? `<span>${option.description}</span>`
              : '');

          button.addEventListener('click', () => {
            answers.push({
              node: nodeKey,
              label: option.label,
              value: option.endpoint || option.next
            });

            track('choice_finder_answer', {
              step_number: answers.length,
              question_id: nodeKey,
              answer_id: option.endpoint || option.next,
              answer_label: option.label
            });

            if (option.endpoint) {
              showEndpoint(option.endpoint);
            } else {
              history.push(nodeKey);
              renderNode(option.next);
            }
          });

          options.appendChild(button);
        });

        setProgress();

        track(
          history.length === 0
            ? 'choice_finder_started'
            : 'choice_finder_step_viewed',
          {
            step_number: history.length + 1,
            question_id: nodeKey
          }
        );
      };

      const bindProductEvents = () => {
        productTarget
          .querySelectorAll('[data-choice-product-link]')
          .forEach((link) => {
            link.addEventListener('click', () => {
              const card = link.closest('[data-product-id]');

              track('choice_finder_product_clicked', {
                endpoint_id: endpointCode,
                collection_handle:
                  endpoints[endpointCode]?.handle,
                product_id: card?.dataset.productId,
                product_handle: card?.dataset.productHandle
              });
            });
          });

        productTarget
          .querySelectorAll('[data-choice-add]')
          .forEach((button) => {
            button.addEventListener('click', async () => {
              const original = button.textContent;

              button.disabled = true;
              button.textContent = 'Toevoegen…';

              try {
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: Number(button.dataset.variantId),
                        quantity: 1
                      }
                    ]
                  })
                });

                if (!response.ok) {
                  throw new Error('Cart add failed');
                }

                const data = await response.json();

                button.textContent = 'Toegevoegd';

                document.dispatchEvent(
                  new CustomEvent('cart:refresh', {
                    bubbles: true
                  })
                );

                track('choice_finder_add_to_cart', {
                  endpoint_id: endpointCode,
                  collection_handle:
                    endpoints[endpointCode]?.handle,
                  variant_id: button.dataset.variantId,
                  product_id:
                    button
                      .closest('[data-product-id]')
                      ?.dataset.productId,
                  cart_item_count: data.items?.length
                });
              } catch (error) {
                button.disabled = false;
                button.textContent = 'Probeer opnieuw';
              }

              setTimeout(() => {
                if (button.textContent === 'Toegevoegd') {
                  button.disabled = false;
                  button.textContent = original;
                }
              }, 2400);
            });
          });
      };

      const showEndpoint = (code) => {
        const endpoint = endpoints[code];

        const template = root.querySelector(
          `template[data-choice-products="${code}"]`
        );

        if (!endpoint || !template) return;

        endpointCode = code;
        quiz.hidden = true;
        result.hidden = false;

        root.querySelector(
          '[data-choice-result-title]'
        ).textContent = endpoint.title;

        root.querySelector(
          '[data-choice-result-text]'
        ).textContent = endpoint.text;

        root.querySelector(
          '[data-choice-chips]'
        ).innerHTML = answers
          .map(
            (answer) =>
              `<span class="ss-choice__chip">${answer.label}</span>`
          )
          .join('');

        productTarget.replaceChildren(
          template.content.cloneNode(true)
        );

        bindProductEvents();

        root.querySelector(
          '[data-choice-collection-link]'
        ).href = `/collections/${endpoint.handle}`;

        root.querySelector(
          '[data-choice-tags]'
        ).value =
          `keuzehulp,keuzehulp_${code.toLowerCase()},` +
          `keuzehulp_collectie_${endpoint.handle}`;

        root.querySelector(
          '[data-choice-return]'
        ).value =
          `${window.location.pathname}` +
          `?ss_choice_success=1` +
          `&ss_endpoint=${encodeURIComponent(code)}` +
          `#${root.id}`;

        root.querySelector(
          '[data-choice-discount]'
        ).hidden = true;

        root.querySelector(
          '[data-choice-signup]'
        ).hidden = false;

        form.hidden = false;

        sessionStorage.setItem(
          sessionKey,
          JSON.stringify({
            endpointCode: code,
            answers
          })
        );

        setProgress();

        track('choice_finder_completed', {
          endpoint_id: code,
          route: answers
            .map((answer) => answer.value)
            .join('>')
        });

        track('choice_finder_result', {
          endpoint_id: code,
          endpoint_title: endpoint.title,
          collection_handle: endpoint.handle,
          recommended_product_count:
            productTarget.querySelectorAll(
              '[data-product-id]'
            ).length
        });
      };

      const revealDiscount = () => {
        const endpoint = endpoints[endpointCode];

        if (!endpoint) return;

        const discount = root.querySelector(
          '[data-choice-discount]'
        );

        root.querySelector(
          '[data-choice-code]'
        ).textContent = endpoint.code;

        root.querySelector(
          '[data-choice-discount-link]'
        ).href =
          `/discount/${encodeURIComponent(endpoint.code)}` +
          `?redirect=/collections/${encodeURIComponent(
            endpoint.handle
          )}`;

        root.querySelector(
          '[data-choice-signup]'
        ).hidden = true;

        discount.hidden = false;

        track('choice_finder_discount_revealed', {
          endpoint_id: endpointCode,
          collection_handle: endpoint.handle,
          discount_code: endpoint.code
        });
      };

      root
        .querySelector('[data-choice-open]')
        .addEventListener('click', open);

      root
        .querySelector('[data-choice-close]')
        .addEventListener('click', close);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          close();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          modal.classList.contains('is-open')
        ) {
          close();
        }
      });

      back.addEventListener('click', () => {
        answers.pop();

        const previous = history.pop() || 'root';

        track('choice_finder_back_clicked', {
          return_to: previous
        });

        renderNode(previous);
      });

      root
        .querySelector('[data-choice-reset]')
        .addEventListener('click', () => {
          history = [];
          answers = [];
          endpointCode = null;

          sessionStorage.removeItem(sessionKey);

          track('choice_finder_reset');

          renderNode('root');
        });

      root
        .querySelector('[data-choice-collection-link]')
        .addEventListener('click', () => {
          track('choice_finder_collection_clicked', {
            endpoint_id: endpointCode,
            collection_handle:
              endpoints[endpointCode]?.handle
          });
        });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const error = root.querySelector(
          '[data-choice-form-error]'
        );

        const submit = root.querySelector(
          '[data-choice-submit]'
        );

        error.hidden = true;
        submit.disabled = true;
        submit.textContent = 'Bezig…';

        track('choice_finder_email_submitted', {
          endpoint_id: endpointCode,
          collection_handle:
            endpoints[endpointCode]?.handle
        });

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: {
              Accept: 'text/html'
            }
          });

          if (!response.ok) {
            throw new Error('Signup failed');
          }

          revealDiscount();
        } catch (requestError) {
          error.textContent =
            'Inschrijven is niet gelukt. Probeer het opnieuw.';

          error.hidden = false;
        } finally {
          submit.disabled = false;
          submit.textContent = 'Toon mijn korting';
        }
      });

      const params = new URLSearchParams(
        window.location.search
      );

      const saved = JSON.parse(
        sessionStorage.getItem(sessionKey) || 'null'
      );

      if (
        params.get('ss_choice_success') === '1' &&
        saved?.endpointCode
      ) {
        answers = saved.answers || [];

        open();
        showEndpoint(saved.endpointCode);
        revealDiscount();
      }

      track('choice_finder_loaded');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ss-mobile-sticky-atc]');

    roots.forEach((root) => {
      const stickySubmit = root.querySelector('[data-ss-sticky-submit]');
      const stickyLabel = root.querySelector('[data-ss-sticky-label]');
      const qtyInput = root.querySelector('[data-ss-qty-input]');
      const productInfo = document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');

      if (!stickySubmit || !qtyInput || !productInfo) return;

      const getMainSubmit = () =>
        productInfo.querySelector('button[id^="ProductSubmitButton-"]');

      const getMainQuantity = () =>
        productInfo.querySelector('input[name="quantity"]');

      const syncRulesAndState = () => {
        const mainSubmit = getMainSubmit();
        const mainQuantity = getMainQuantity();

        if (!mainSubmit) {
          stickySubmit.disabled = true;
          return;
        }

        stickySubmit.disabled =
          mainSubmit.disabled ||
          mainSubmit.getAttribute('aria-disabled') === 'true' ||
          mainSubmit.classList.contains('loading');

        const sourceText = mainSubmit.querySelector('span:not(.sold-out-message)')?.textContent?.trim();
        if (sourceText) {
          stickySubmit.setAttribute('aria-label', sourceText);
          if (stickyLabel) stickyLabel.textContent = sourceText;
        }

        if (mainQuantity) {
          qtyInput.min = mainQuantity.min || '1';
          qtyInput.step = mainQuantity.step || '1';

          if (mainQuantity.max) qtyInput.max = mainQuantity.max;
          else qtyInput.removeAttribute('max');

          if (document.activeElement !== qtyInput) {
            qtyInput.value = mainQuantity.value || qtyInput.min || '1';
          }
        }
      };

      qtyInput.addEventListener('change', () => {
        const mainQuantity = getMainQuantity();
        if (!mainQuantity) return;

        mainQuantity.value = qtyInput.value;
        mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      });

      stickySubmit.addEventListener('click', () => {
        const mainSubmit = getMainSubmit();
        const mainQuantity = getMainQuantity();
        if (!mainSubmit) return;

        if (mainQuantity) {
          mainQuantity.value = qtyInput.value;
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncRulesAndState();
        if (!stickySubmit.disabled) mainSubmit.click();
      });

      const productObserver = new MutationObserver(syncRulesAndState);
      productObserver.observe(productInfo, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      syncRulesAndState();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
